import { useTranslation } from "@localization/useTranslation";
import { FrameworkControlStatus } from "../../framework/frameworks/Frameworks.types";
import FrameworkControlStatusChip from "../../framework/frameworkOverview/frameworkControlStatusChip/FrameworkControlStatusChip";

interface LinkedControlStatusProps {
    status: FrameworkControlStatus | null;
}

// The rolled-up linked-control status chip (any Overdue wins), shared by the entity-level and operational risk
// overviews. Renders nothing when no status is resolved (no linked controls).
function LinkedControlStatus({ status }: LinkedControlStatusProps) {
    const { translateFrameworkControlStatusEnum } = useTranslation();

    if (status == null) return null;

    return <FrameworkControlStatusChip isExcluded={false} status={status} value={translateFrameworkControlStatusEnum(status.toString())} />;
}

export default LinkedControlStatus;
